import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useDispatch, useSelector } from 'react-redux'

import { verificationStatusSelector } from './selectors'
import {
  VERIFICATION_AWAITING,
  VERIFICATION_RESENDING_CODE,
  resendVerificationCode
} from './slice'

export const ResendCodeButton = ({ phoneNumber, ownerId }) => {
  const dispatch = useDispatch()

  const fieldStatus = useSelector(verificationStatusSelector)

  const updateVerificationCode = () => {
    dispatch(resendVerificationCode(ownerId, phoneNumber))
  }

  const resendingCode = fieldStatus === VERIFICATION_RESENDING_CODE

  if (fieldStatus !== VERIFICATION_AWAITING && !resendingCode) { return null }

  return (
    <Button
      size="small"
      loading={resendingCode}
      onClick={updateVerificationCode}
      decoration="outline"
    >
      {I18n.t('publisher.workflows.actions.sms.resend')}
    </Button>
  )
}
